import { type BeforeErrorState, isHTTPError } from 'ky';

import { isDefined } from '@enterprise/core';

/**
 * Logs detailed information about HTTP errors encountered during requests.
 *
 * This hook is intended to be used with the `ky` HTTP client as a `beforeError` hook.
 * It checks if the error is an HTTP error, and if so, logs the request and response
 * details (if available) to the console for debugging purposes.
 *
 * @param state - The error state object containing the error to be logged.
 * @returns The original error, either synchronously or as a Promise.
 */
export const logError = ({ error }: BeforeErrorState): Error | Promise<Error> => {
  if (isHTTPError(error)) {
    const { request, response, ...errorDetails } = error;

    if (isDefined(request)) {
      console.groupCollapsed(`Request Error: ${request.url}`);
      console.dir(errorDetails);
      console.groupEnd();
    }

    if (isDefined(response)) {
      console.groupCollapsed(`Response Error: ${response.url}`);
      console.dir(errorDetails);
      console.groupEnd();
    }
  }

  return error;
};
